import LangEnum from '../../../../../../lang/LangEnum';
import { ActionEnum } from '../../../../actions/types/orderActions.types';
import { OrderActionProps } from '../../../../actions/types/orderActionsContext.types';
import { useOrderContext } from '../../../../contexts/Order.context';
import { useOrderActionsContext } from '../../../../contexts/OrderActions.context';
import OrderSummaryActionButton from './OrderSummaryActionButton';

const UnarchiveSuggestedOrderButton = () => {
  const { order } = useOrderContext();
  const { onClickOrderAction } = useOrderActionsContext();

  return (
    <OrderSummaryActionButton
      label={LangEnum.GLOBAL_UNARCHIVE}
      onClick={() =>
        order &&
        onClickOrderAction(ActionEnum.UNARCHIVE_ORDER, OrderActionProps.orderToProps(order))
      }
    />
  );
};

export default UnarchiveSuggestedOrderButton;
